import { AxiosResponse } from 'axios';
import axios from 'axios';
import { Objeto } from '../../Models';
import Context from '../../context';

class Identificador {
    /* #region  GET Controller  */
    /* Sobre esta função *//**
     * Lista as unidades disponíveis vinculadas a uma empresa e centro de custo específico
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe o código do centro de custo (sigla)
     **/
    public async Get(Token: string, Empresa: Number, CentroDeCusto: string): Promise<AxiosResponse<Array<Objeto.Identificador>>> {
        return await Context.get(`/Identificador/${Token}/${Empresa}/${CentroDeCusto}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };

    /* Sobre esta função *//**
     * Lista as unidades disponíveis vinculadas a uma empresa e centro de custo específico
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe o código do centro de custo (sigla)
     * @param {number} Local Informe o código do local (id)
     * @param {number} Sublocal Informe o código do sublocal (id)
     **/
    public async Get1(Token: string, Empresa: Number, CentroDeCusto: string, Local: number, Sublocal: number): Promise<AxiosResponse<Array<Objeto.Identificador>>> {
        return await Context.get(`/Identificador/${Token}/${Empresa}/${CentroDeCusto}/${Local}/${Sublocal}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* Sobre esta função *//**
     * Retorna os filtros aplicaveis a empresa e centro de custo informado
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe o código do centro de custo (sigla)
     **/
    public async FiltrosAplicaveis(Token: string, Empresa: Number, CentroDeCusto: string): Promise<AxiosResponse<Array<Objeto.Filtro>>> {
        return await Context.get(`/Identificador/FiltrosAplicaveis/${Token}/${Empresa}/${CentroDeCusto}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* Sobre esta função *//**
     * Lista as unidades disponíveis vinculadas a uma empresa e centro de custo específico
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe o código do centro de custo (sigla)
     **/
    public async Get3(Token: string, Empresa: Number, CentroDeCusto: string): Promise<AxiosResponse<{ imagemMapaDoLoteamento: { descricao: string, extensao: string, arquivo: string }, lista: Array<{ quadra: string, lotes: Array<{ lote: string, Posicao: Objeto.CoordenadaGeografica, objeto: Objeto.Identificador}>}>, statusDaInadimplencia: Array<{descricao: string, cor: string}>}>> {
        return await Context.get(`/Identificador/${Token}/${Empresa}/${CentroDeCusto}?ExibirMapaDoLoteamento=true`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Reserva o lote selecionado
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     **/
    public async ReservarUnidades(Token: string, Identificador: Array<Objeto.Identificador>): Promise<AxiosResponse<Array<Objeto.Identificador>>> {
        return await Context.post(`/Identificador/ReservarUnidades/${Token}`, Identificador)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Reserva o lote selecionado
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Timer Informe o tempo de reserva (em minutos)"
     **/
    public async ReservarUnidadesComTimer(Token: string, Timer: number, Identificador: Array<Objeto.Identificador>): Promise<AxiosResponse<Array<Objeto.Identificador>>> {
        return await Context.post(`/Identificador/ReservarUnidades/${Token}?TempoDeReserva=${Timer}`, Identificador)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  DELETE Controller  */
    /* Sobre esta função *//**
     * Disponibiliza o lote selecionado
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     **/
    public async DeletarReservas(Token: string, Identificador: Array<Objeto.Identificador>): Promise<AxiosResponse<Array<Objeto.Identificador>>> {
        return axios({
            method: 'DELETE',
            baseURL: ((window.location.href.includes("test") || window.location.href.includes("local")) ? "http://testapi.oneplus.dev.br" : "http://api.oneplus.dev.br") + '/Identificador/DeletarReservas/' + Token,
            data: Identificador,
            headers: { 'Content-Type': 'application/json; charset=utf-8' },
        })
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* #region  DELETE Controller  */
    /* Sobre esta função *//**
     * Deletar categorias
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe o código do centro de custo (sigla)
     * @param {string} Sigla Informe a sigla da categoria (sigla)
     **/
    public async DeletarCategoria(Token: string, Empresa: Number, CentroDeCusto: string, Sigla: string): Promise<any> {
        return await Context.delete(`/Identificador/DeletarCategoriaDeReserva/${Token}/${Empresa}/${CentroDeCusto}/${Sigla}`)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */

    /* Sobre esta função *//**
     * Lista todas as categorias de reserva relacionadas a um centro de custo especifíco.
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     * @param {number} Empresa Informe o código da empresa (id). A lista das empresas cadastradas poderá ser obtida ao executar a requisição "/Empresa/{Token}"
     * @param {string} CentroDeCusto Informe o código do centro de custo (sigla)
     **/
        public async CategoriasDeReserva(Token: string, Empresa: Number, CentroDeCusto: string): Promise<any> {
            return await Context.get(`/Identificador/CategoriaDeReserva/${Token}/${Empresa}/${CentroDeCusto}`)
                .then((Response) => { return Response; })
                .catch((Exception) => { return Exception; });
        };
    /* #endregion */

    /* Sobre esta função *//**
     * Lista todas as categorias de reserva.
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     **/
        public async TodasCategoriasDeReserva(Token: string): Promise<any> {
            return await Context.get(`/Identificador/CategoriaDeReserva/${Token}`)
                .then((Response) => { return Response; })
                .catch((Exception) => { return Exception; });
        };
    /* #endregion */

    /* #region  POST Controller  */
    /* Sobre esta função *//**
     * Cadastrar nova categoria de reserva.
     * @param {string} Token Informe o token de acesso do usuário obtido ao executar a requisição "/Logon/{CPF}/{Senha}"
     **/
    public async NovaCategoriaDeReserva(Token: string, Identificador: Array<any>): Promise<any> {
        return await Context.post(`/Identificador/NovaCategoriaDeReserva/${Token}`, Identificador)
            .then((Response) => { return Response; })
            .catch((Exception) => { return Exception; });
    };
    /* #endregion */
};

export default new Identificador();